import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ContainerResizeListener from '../ContainerResizeListener';
import IconStand from '../../widgets/Status/IconStand';
import ShipmentStatusIcon from '../../widgets/Status/ShipmentStatus/ShipmentStatusIcon';
import { getTranslatedInfo, errorTypes } from './errorMessageHelper';

import './ErrorPage.module.scss';

function ErrorPage({ type, language }) {
  const [isMobile, setMobile] = useState(0);
  const { title, message } = getTranslatedInfo(type, language);

  return (
    <ContainerResizeListener
      onResize={({ width }) => setMobile(width <= 768)}
      styleName={classNames('container', { mobile: isMobile })}
    >
      <div role="alert" styleName={classNames('container', { mobile: isMobile })} lang={language}>
        <IconStand size={isMobile ? 116 : 186} iconBackgroundColor="#00B1E1">
          <ShipmentStatusIcon name={getIcon(type)} size={isMobile ? 48 : 64} fill="#FFFFFF" />
        </IconStand>
        <h1 styleName="title">{title}</h1>
        <span styleName="sub-title">{message}</span>
      </div>
    </ContainerResizeListener>
  );
}

const iconTypes = {
  infoGeneral: 'info-general',
  lost: 'lost',
};

function getIcon(errorType) {
  return errorType === errorTypes.noInfo ? iconTypes.infoGeneral : iconTypes.lost;
}

ErrorPage.propTypes = {
  type: PropTypes.oneOf(['not-found', 'error', 'no-info']).isRequired,
  language: PropTypes.string,
};

export default ErrorPage;
